import { useEffect, useState } from 'react';
import useClient from 'api/client';
import { useAlert } from 'components/message/AlertContext';
import { useParams } from 'react-router-dom';
import { SearchFilter } from 'types/Filters';
import { PaginationItems } from 'types/Pagination';
import listDatasetShareObjects from 'api/ShareObject/listDatasetShareObjects';
import { ShareObjectStatus } from 'types/Share';

export interface DatasetPermissions {
    owner: string;
    samlGroupName: string;
    environmentName: string;
    created: string;
    status: ShareObjectStatus;
    approver: string;
    action: React.JSX.Element;
    shareUri: string;
}
export default function usePermissions(filter: SearchFilter) {
    const client = useClient();
    const { openAlert } = useAlert();
    const params = useParams<{ uri: string }>();
    const [showSearchbar, setShowSearchbar] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [permissions, setPermissions] = useState<DatasetPermissions[]>([]);
    const [items, setItems] = useState<PaginationItems>({
        count: 0,
        pages: 0,
        page: 0,
    });

    useEffect(() => {
        const fetchData = async () => {
            if (params.uri)
                try {
                    setLoading(true);
                    const response = await client?.query(
                        listDatasetShareObjects(params.uri, filter),
                    );
                    if (!response.errors) {
                        setPermissions(response.data.getDataset.shares.nodes);
                        setItems(response.data.getDataset.shares);
                        if (
                            response.data.getDataset.shares.count !== 0 &&
                            !showSearchbar
                        ) {
                            setShowSearchbar(true);
                        }
                    } else {
                        setError(true);
                        openAlert({
                            message: response.errors[0]?.message,
                            severity: 'alert',
                        });
                    }
                } finally {
                    setLoading(false);
                }
        };

        if (client) {
            fetchData();
        }
    }, [client, params.uri, filter]);

    return {
        permissions,
        error,
        loading,
        items,
        showSearchbar,
    };
}
